<script setup lang="ts">
import noop from 'lodash/noop'
import {
  LOCALES,
  currentLocale,
  useI18n,
  switchLocale,
} from '@papershift/locale/src/i18n'
import LocaleSwitcher from '../components/LocaleSwitcher.vue'
import AuthSplitScreen from '../views/marketing/AuthSplitScreen.vue'

const { t } = useI18n()

defineProps<{
  title: string
}>()
defineSlots<{
  subtitle?: any
  form: any
}>()

// we need some dummy JS code to get sourcemaps generated
// https://github.com/cenfun/monocart-reporter/issues/33#issuecomment-1594033026
noop()
</script>

<template>
  <div class="lg:flex min-h-screen bg-neutral-50">
    <div
      class="grid grid-flow-row px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24 overflow-y-auto max-h-screen"
    >
      <LocaleSwitcher
        class="ml-auto mt-4"
        :locales="LOCALES"
        :current-locale="currentLocale"
        @locale-change="switchLocale($event)"
      />

      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <h2 class="mt-6 text-3xl font-bold tracking-tight text-slate-700">
            {{ title }}
          </h2>
          <p class="mt-2 text-sm text-slate-600">
            <slot name="subtitle" />
          </p>
        </div>

        <div class="mt-8">
          <div class="mt-6">
            <slot name="form" />
          </div>
        </div>
      </div>

      <div class="text-center pb-0 pt-20 flex justify-center space-x-4">
        <a :href="t('legal_notice.link')" target="_blank">
          <p class="mt-6 text-xs text-slate-500">
            {{ t('legal_notice.label') }}
          </p>
        </a>
        <a :href="t('privacy.link')" target="_blank">
          <p class="mt-6 text-xs text-slate-500">
            {{ t('privacy.label') }}
          </p>
        </a>
      </div>
    </div>

    <AuthSplitScreen />
  </div>
</template>

/* v8 ignore start */
<i18n locale="en">
legal_notice:
  label: Legal Notice
  link: https://pulse-docs.papershift.com/en/legal-notice
privacy:
  label: Privacy Policy
  link: https://pulse-docs.papershift.com/en/privacy-policy
</i18n>

<i18n locale="de">
legal_notice:
  label: Impressum
  link: https://pulse-docs.papershift.com/de/legal-notice
privacy:
  label: Datenschutzerklärung
  link: https://pulse-docs.papershift.com/de/privacy-policy
  </i18n>
/* v8 ignore stop */
